import { useParams } from "react-router";

import * as Filters from "@app/analytics/meetops/filters";
import { ParsedMetric } from "@app/analytics/meetops/metrics";
import { PROD_SAMPLE_MEETING } from "@app/analytics/sampleData/sampleMeetings";
import { parseMetricsDataFromQueryResult } from "@app/analytics/utils";
import useAuth from "@app/common/auth/useAuth";

import useMeetingReportMetricsQuery from "./useMeetingReportMetricsQuery";

type UserAttendanceData = { participantAttendance: ParsedMetric };

const DEFAULT_USER_ATTENDANCE_DATA: UserAttendanceData = {
  participantAttendance: {
    id: "",
    value: null,
    rawValue: null,
    formattedValue: "-",
  },
};

const useUserAttendance = ({ enabled } = { enabled: true }) => {
  const { user } = useAuth();
  const { sessionId } = useParams();

  const isSampleReport = sessionId === PROD_SAMPLE_MEETING.id;

  const userLoggedIn = Boolean(user?.id);

  const { data, isInitialLoading } = useMeetingReportMetricsQuery(
    {
      metrics: ["participantAttendance"],
      filters: [Filters.isUser(user?.id ?? "")],
    },
    {
      queryKey: ["coachingAttendance", sessionId, user?.id],
      enabled: enabled && Boolean(sessionId) && userLoggedIn && !isSampleReport,
    }
  );

  const [myAttendanceData] =
    parseMetricsDataFromQueryResult<UserAttendanceData>(
      data,
      DEFAULT_USER_ATTENDANCE_DATA
    );

  const userWasInMeeting =
    (myAttendanceData?.participantAttendance?.rawValue ?? 0) > 0;

  return {
    isInitialLoading,
    wasInMeeting: isSampleReport || (userLoggedIn && userWasInMeeting),
  };
};

export default useUserAttendance;
